import React from 'react';
import { Icon } from '../icon/icon.tsx';
import { classList } from '../../../utils/string.ts';
import { randomId } from '../../../components/tracking/ubtracking/ub-utils.ts';

export type InputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  id?: string;
  iconName?: string;
  label?: string;
  className?: string;
};

/**
 * TODO Add disabled attribute handling.
 */
export const Input: React.FunctionComponent<InputProps> = ({
  id,
  iconName,
  label,
  className,
  ...htmlAttributes
}) => {
  id = id ?? randomId();

  return (
    <div className="relative">
      <input
        {...htmlAttributes}
        id={id}
        className={classList(
          'bg-sk-grey-200 peer text-sk-blue-500 rounded-lg pt-[18px] pb-0.5 pl-4 text-sm placeholder:text-transparent disabled:pointer-events-none disabled:cursor-default disabled:opacity-50',
          iconName ? 'pr-9' : 'pr-4',
          className
        )}
        placeholder={label}
      />
      {label && (
        <label
          className="text-sk-grey-900 peer-placeholder-shown:text-sk-blue-500 peer-focus:text-sk-grey-900 pointer-events-none absolute top-0.5 left-4 text-xs transition-all duration-200 ease-in-out peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-sm peer-focus:top-0.5 peer-focus:text-xs"
          htmlFor={id}
        >
          {label}
        </label>
      )}
      {iconName && (
        <Icon
          name={iconName}
          className="relative -top-2.5 -ml-[30px] p-[5px] align-middle text-sm"
        />
      )}
    </div>
  );
};
